import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PaymentMethods = () => {
  const [showAddModal, setShowAddModal] = useState(false);
  const [selectedMethod, setSelectedMethod] = useState(null);
  const [newCardForm, setNewCardForm] = useState({
    cardNumber: '',
    expiryDate: '',
    cvv: '',
    cardholderName: '',
    isDefault: false
  });

  const paymentMethods = [
    {
      id: '1',
      type: 'visa',
      lastFour: '1234',
      expiryDate: '12/26',
      cardholderName: 'Alexandre Dubois',
      isDefault: true,
      isExpired: false
    },
    {
      id: '2',
      type: 'mastercard',
      lastFour: '5678',
      expiryDate: '08/25',
      cardholderName: 'Alexandre Dubois',
      isDefault: false,
      isExpired: false
    },
    {
      id: '3',
      type: 'visa',
      lastFour: '9012',
      expiryDate: '03/25',
      cardholderName: 'Alexandre Dubois',
      isDefault: false,
      isExpired: true
    }
  ];

  const getCardIcon = (type) => {
    const iconMap = {
      visa: 'CreditCard',
      mastercard: 'CreditCard',
      amex: 'CreditCard',
      discover: 'CreditCard'
    };
    return iconMap?.[type] || 'CreditCard';
  };

  const getCardColor = (type) => {
    const colorMap = {
      visa: 'text-primary',
      mastercard: 'text-accent',
      amex: 'text-success',
      discover: 'text-warning'
    };
    return colorMap?.[type] || 'text-muted-foreground';
  };

  const getCardName = (type) => {
    const nameMap = {
      visa: 'Visa',
      mastercard: 'Mastercard',
      amex: 'American Express',
      discover: 'Discover'
    };
    return nameMap?.[type] || 'Carte';
  };

  const handleSetDefault = (methodId) => {
    console.log('Setting default payment method:', methodId);
    // Here you would update the default payment method
  };

  const handleDeleteMethod = (methodId) => {
    console.log('Deleting payment method:', methodId);
    // Here you would delete the payment method
  };

  const handleAddCard = () => {
    console.log('Adding new card:', newCardForm);
    setShowAddModal(false);
    setNewCardForm({
      cardNumber: '',
      expiryDate: '',
      cvv: '',
      cardholderName: '',
      isDefault: false
    });
  };

  const formatCardNumber = (value) => {
    const cleaned = value?.replace(/\s/g, '');
    const formatted = cleaned?.match(/.{1,4}/g)?.join(' ') || cleaned;
    return formatted;
  };

  const formatExpiryDate = (value) => {
    const cleaned = value?.replace(/\D/g, '');
    const formatted = cleaned?.length >= 2 
      ? cleaned?.substring(0, 2) + (cleaned?.length > 2 ? '/' + cleaned?.substring(2, 4) : '')
      : cleaned;
    return formatted;
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6 shadow-sm">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-semibold text-card-foreground">
            Méthodes de paiement
          </h3>
          <p className="text-sm text-muted-foreground">
            Gérez vos cartes de crédit et méthodes de paiement
          </p>
        </div>
        
        <Button
          variant="default"
          size="sm"
          iconName="Plus"
          iconPosition="left"
          iconSize={16}
          onClick={() => setShowAddModal(true)}
        >
          Ajouter une carte
        </Button>
      </div>
      {/* Payment Methods List */}
      <div className="space-y-4">
        {paymentMethods?.map((method) => (
          <div
            key={method?.id}
            className={`relative border rounded-lg p-4 transition-all ${
              method?.isDefault 
                ? 'border-accent bg-accent/5 ring-2 ring-accent/20' 
                : method?.isExpired
                ? 'border-error/30 bg-error/5' :'border-border hover:border-accent/50'
            }`}
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-4">
                <div className={`flex items-center justify-center w-12 h-12 rounded-lg ${
                  method?.isExpired ? 'bg-error/10' : 'bg-muted/50'
                }`}>
                  <Icon 
                    name={getCardIcon(method?.type)} 
                    size={24} 
                    className={method?.isExpired ? 'text-error' : getCardColor(method?.type)}
                  />
                </div>
                
                <div>
                  <div className="flex items-center space-x-3 mb-1">
                    <p className="font-medium text-card-foreground">
                      {getCardName(method?.type)} •••• {method?.lastFour}
                    </p>
                    {method?.isDefault && (
                      <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-success/10 text-success">
                        <Icon name="Check" size={10} className="mr-1" />
                        Défaut
                      </span>
                    )}
                    {method?.isExpired && (
                      <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-error/10 text-error">
                        <Icon name="AlertTriangle" size={10} className="mr-1" />
                        Expirée
                      </span>
                    )}
                  </div>
                  <div className="flex items-center space-x-4 text-sm text-muted-foreground">
                    <span>Expire {method?.expiryDate}</span>
                    <span>•</span>
                    <span>{method?.cardholderName}</span>
                  </div>
                </div>
              </div>

              <div className="flex items-center space-x-2">
                {!method?.isDefault && !method?.isExpired && (
                  <Button
                    variant="ghost"
                    size="sm"
                    iconName="Star"
                    onClick={() => handleSetDefault(method?.id)}
                    title="Définir par défaut"
                  />
                )}
                
                <Button
                  variant="ghost"
                  size="sm"
                  iconName="Settings"
                  onClick={() => setSelectedMethod(method)}
                  title="Modifier"
                />
                
                <Button
                  variant="ghost"
                  size="sm"
                  iconName="Trash2"
                  onClick={() => handleDeleteMethod(method?.id)}
                  className="text-error hover:text-error"
                  title="Supprimer"
                />
              </div>
            </div>

            {method?.isExpired && (
              <div className="mt-3 pt-3 border-t border-error/20">
                <div className="flex items-start space-x-2">
                  <Icon name="AlertTriangle" size={16} className="text-error mt-0.5" />
                  <div>
                    <p className="text-sm font-medium text-error">
                      Cette carte a expiré
                    </p>
                    <p className="text-xs text-error/80 mt-1">
                      Mettez à jour vos informations de paiement pour éviter toute interruption de service.
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
      {paymentMethods?.length === 0 && (
        <div className="text-center py-8">
          <Icon name="CreditCard" size={48} className="text-muted-foreground mx-auto mb-4" />
          <p className="text-muted-foreground mb-4">Aucune méthode de paiement enregistrée</p>
          <Button
            variant="default"
            iconName="Plus"
            iconPosition="left"
            iconSize={16}
            onClick={() => setShowAddModal(true)}
          >
            Ajouter votre première carte
          </Button>
        </div>
      )}
      {/* Security Information */}
      <div className="mt-6 pt-6 border-t border-border">
        <div className="bg-muted/50 rounded-lg p-4">
          <div className="flex items-start space-x-3">
            <Icon name="Shield" size={18} className="text-success mt-0.5" />
            <div>
              <h4 className="text-sm font-medium text-card-foreground mb-2">
                Sécurité des paiements
              </h4>
              <div className="text-xs text-muted-foreground space-y-1">
                <p>• Toutes les transactions sont sécurisées par cryptage SSL 256-bit</p>
                <p>• Vos informations de carte ne sont jamais stockées sur nos serveurs</p>
                <p>• Nous utilisons Stripe pour traiter tous les paiements de manière sécurisée</p>
                <p>• Vous pouvez supprimer vos méthodes de paiement à tout moment</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Add Card Modal */}
      {showAddModal && (
        <div className="fixed inset-0 bg-background/80 backdrop-blur-sm flex items-center justify-center z-50">
          <div className="bg-card border border-border rounded-lg p-6 w-full max-w-md mx-4">
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-lg font-semibold text-card-foreground">
                Ajouter une carte
              </h3>
              <Button
                variant="ghost"
                size="sm"
                iconName="X"
                onClick={() => setShowAddModal(false)}
              />
            </div>

            <form className="space-y-4" onSubmit={(e) => { e?.preventDefault(); handleAddCard(); }}>
              <div>
                <label className="text-sm font-medium text-card-foreground mb-2 block">
                  Numéro de carte
                </label>
                <input
                  type="text"
                  value={newCardForm?.cardNumber}
                  onChange={(e) => setNewCardForm(prev => ({
                    ...prev,
                    cardNumber: formatCardNumber(e?.target?.value)
                  }))}
                  placeholder="1234 5678 9012 3456"
                  maxLength={19}
                  className="w-full px-3 py-2 bg-background border border-border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-accent"
                  required
                />
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="text-sm font-medium text-card-foreground mb-2 block">
                    Date d'expiration
                  </label>
                  <input
                    type="text"
                    value={newCardForm?.expiryDate}
                    onChange={(e) => setNewCardForm(prev => ({
                      ...prev,
                      expiryDate: formatExpiryDate(e?.target?.value)
                    }))}
                    placeholder="MM/AA"
                    maxLength={5}
                    className="w-full px-3 py-2 bg-background border border-border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-accent"
                    required
                  />
                </div>
                <div>
                  <label className="text-sm font-medium text-card-foreground mb-2 block">
                    CVV
                  </label>
                  <input
                    type="text"
                    value={newCardForm?.cvv}
                    onChange={(e) => setNewCardForm(prev => ({
                      ...prev,
                      cvv: e?.target?.value?.replace(/\D/g, '')?.substring(0, 4)
                    }))}
                    placeholder="123"
                    maxLength={4}
                    className="w-full px-3 py-2 bg-background border border-border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-accent"
                    required
                  />
                </div>
              </div>

              <div>
                <label className="text-sm font-medium text-card-foreground mb-2 block">
                  Nom du titulaire
                </label>
                <input
                  type="text"
                  value={newCardForm?.cardholderName}
                  onChange={(e) => setNewCardForm(prev => ({
                    ...prev,
                    cardholderName: e?.target?.value
                  }))}
                  placeholder="Alexandre Dubois"
                  className="w-full px-3 py-2 bg-background border border-border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-accent"
                  required
                />
              </div>

              <div className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  id="isDefault"
                  checked={newCardForm?.isDefault}
                  onChange={(e) => setNewCardForm(prev => ({
                    ...prev,
                    isDefault: e?.target?.checked
                  }))}
                  className="rounded border-border text-accent focus:ring-accent"
                />
                <label htmlFor="isDefault" className="text-sm text-card-foreground">
                  Définir comme méthode de paiement par défaut
                </label>
              </div>

              <div className="flex space-x-3 pt-4">
                <Button
                  type="button"
                  variant="outline"
                  fullWidth
                  onClick={() => setShowAddModal(false)}
                >
                  Annuler
                </Button>
                <Button
                  type="submit"
                  variant="default"
                  fullWidth
                  iconName="CreditCard"
                  iconPosition="left"
                  iconSize={16}
                >
                  Ajouter la carte
                </Button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default PaymentMethods;